import { FieldValidator } from 'final-form'
import { validateRequiredNumber, validateRequiredNumberBetween } from 'utils/validation'
import { PT_MIN_SCORES } from './consts'

export const validatePTMinScore = (platformSlug: string) => (value?: string) => {
  const required = validateRequiredNumber(value)
  if (required) {
    return required
  }

  return PT_MIN_SCORES[platformSlug] <= Number(value) ? undefined : `Must be at least ${PT_MIN_SCORES[platformSlug]}`
}

export const validateBreakDuration = (value?: string) => {
  const required = validateRequiredNumber(value)

  if (required) {
    return required
  }

  return validateRequiredNumberBetween(value, 1, 60)
}

export type BreakSectionFormItem = {
  id?: string
  questionIndex?: number | string
  duration?: number | string
}

type PracticeTestFormValues = {
  questions?: unknown[]
}

const getQuestionsCount = (allValues: object) => (allValues as PracticeTestFormValues).questions?.length ?? 0

export const validateBreakQuestionIndex = (value?: string, allValues?: object) => {
  const questionsCount = getQuestionsCount(allValues ?? {})

  if (questionsCount < 2) {
    return 'Add at least 2 questions to configure breaks'
  }

  return validateRequiredNumberBetween(value, 1, questionsCount - 1)
}

export const validateBreakSections: FieldValidator<BreakSectionFormItem[]> = (value, allValues) => {
  const questionsCount = getQuestionsCount(allValues ?? {})

  if (!value?.length) {
    return undefined
  }

  const questionIndixes = value.map((item) => String(item.questionIndex))
  const duplicateIndixes = questionIndixes.filter(
    (index, i) => index !== '' && index !== undefined && questionIndixes.indexOf(index) !== i
  )

  const errors = value.reduce((acc, item, index) => {
    const itemErrors: Record<string, string> = {}

    if (duplicateIndixes.includes(String(item.questionIndex))) {
      itemErrors.questionIndex = 'Must be unique'
    }

    if (
      item.duration !== undefined &&
      item.duration !== '' &&
      (Number(item.duration) < 1 || Number(item.duration) > 60)
    ) {
      itemErrors.duration = 'Must be from 1 to 60'
    }

    return Object.keys(itemErrors).length ? { ...acc, [index]: itemErrors } : acc
  }, {} as Record<number, Record<string, string>>)

  if (Object.keys(errors).length) {
    return errors
  }

  if (questionsCount < 2) {
    return 'Add at least 2 questions to configure breaks'
  }
}
